import { Injectable } from '@angular/core';
import { PackingDetails, ProductDetail, ProductDevelopment, ProductFeature } from '../types';

@Injectable({
    providedIn: 'root', // This makes the service a singleton available throughout the app.
})
export class StringToJsonConversion {

    convertProductFeature(string: string): ProductFeature | null {
        try {
            return JSON.parse(string)
        } catch (error) {
            return null
        }
    }

    convertProductDetails(string: string): ProductDetail | null {
        try {
            return JSON.parse(string)
        } catch (error) {
            const pdJsonString = string.replace(/\\/g, '"')
            return JSON.parse(pdJsonString);
        }
    }

    convertPackingDetails(string: string): PackingDetails | null {
        try {
            let pkdetails = string.replace(/\\/g, '"')
            return JSON.parse(pkdetails)
        } catch (error) {
            // const pdJsonString = string.replace(/\\/g, '"')
            // return JSON.parse(pdJsonString);
            return null
        }
    }

    convertProductDevelopment(string: string): ProductDevelopment | null {
        try {
            const prestring = JSON.parse(string)
            return JSON.parse(prestring)
        } catch (error) {
            const pdJsonString = string.replace(/\\/g, '"').replace(/^"(.*)"$/, '$1')
            return JSON.parse(pdJsonString);
        }
    }

}